import React from 'react';
import { createPortal } from 'react-dom';
import MagicButton from 'components/MagicButton/MagicButton';
import { AssetUrls } from 'config/assets';
import './ConfirmDismissModal.css';

interface Props {
  isOpen: boolean;
  title: string;
  body: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
  isLoading?: boolean;
}

const ConfirmDismissModal: React.FC<Props> = ({
  isOpen,
  title,
  body,
  confirmLabel = 'Dismiss',
  onConfirm,
  onClose,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  const modalContent = (
    <div className="confirm-dismiss-modal-overlay" onClick={onClose}>
      <div className="confirm-dismiss-modal" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-dismiss-modal-header">
          <h2 className="confirm-dismiss-modal-title">{title}</h2>
          <button
            className="confirm-dismiss-close-button"
            onClick={onClose}
            disabled={isLoading}
            type="button"
            aria-label="Close"
          >
            <img
              src={AssetUrls.icons.dropdowns.close}
              alt=""
              style={{ width: 16, height: 16 }}
            />
          </button>
        </div>
        <div className="confirm-dismiss-modal-content">
          <p>{body}</p>
        </div>
        <div className="confirm-dismiss-modal-footer">
          <MagicButton
            label="Cancel"
            color="grey"
            onPress={onClose}
            isDisabled={isLoading}
            fullWidth={false}
          />
          <MagicButton
            label={isLoading ? `${confirmLabel}...` : confirmLabel}
            color="purple"
            onPress={onConfirm}
            isLoading={isLoading}
            isDisabled={isLoading}
            fullWidth={false}
          />
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default ConfirmDismissModal;
